import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import StatsSection from '@/pages/home/components/StatsSection';
import LearningFormat from '@/pages/home/components/LearningFormat';
import PotentialSection from '@/pages/home/components/PotentialSection';
import AwardsCarousel from '@/pages/home/components/AwardsCarousel';
import OffersSection from '@/pages/home/components/OffersSection';
import NanitPackage from '@/pages/home/components/NanitPackage';
import OpenSourceSection from '@/pages/home/components/OpenSourceSection';
import MarqueeStrip from '@/pages/home/components/MarqueeStrip';
import RobotPossibilities from '@/pages/home/components/RobotPossibilities';
import CartoonSection from '@/pages/home/components/CartoonSection';
import ReviewsSection from '@/pages/home/components/ReviewsSection';
import ContactSection from '@/pages/home/components/ContactSection';
import Footer from '@/pages/home/components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen font-inter">
      <Navbar />
      <Hero />
      <StatsSection />
      <LearningFormat />
      <PotentialSection />
      <AwardsCarousel />
      <OffersSection />
      <NanitPackage />
      <OpenSourceSection />
      <MarqueeStrip />
      <RobotPossibilities />
      <CartoonSection />
      <ReviewsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
